var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEksCluster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cluster__Grouping Type=cluster, State=Enabled",
    className: "cluster__Grouping cluster__Type=cluster, cluster__State=Enabled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cluster__Amazon-Elastic-Container-Kubernetes_Icon_64_Squid",
    fill: "#212B36",
    fillRule: "evenodd",
    d: "m14.238 9.087-2.41 2.78 2.622 3.04h-.979l-2.353-2.732v2.807h-.706V9.018h.706v2.456l2.181-2.387h.94Zm6.056 5.627-2.823-1.685V9.018a.35.35 0 0 0-.175-.304l-4.06-2.354V2.966l7.058 4.147v7.6Zm.533-8.104-7.765-4.56a.351.351 0 0 0-.533.302v4.21c0 .125.067.24.175.304l4.06 2.354v4.01a.35.35 0 0 0 .172.3l3.53 2.105a.353.353 0 0 0 .534-.3V6.911a.35.35 0 0 0-.173-.302ZM11.98 21.25l-8.275-4.373V7.113l7.059-4.147v3.403L7.045 8.72a.351.351 0 0 0-.163.297v5.964c0 .131.074.251.19.312l4.748 2.456a.354.354 0 0 0 .325 0l4.607-2.366 2.835 1.691-7.606 4.175Zm8.495-4.463-3.53-2.106a.355.355 0 0 0-.343-.01l-4.619 2.372-4.396-2.273V9.21l3.72-2.352a.351.351 0 0 0 .163-.297v-4.21a.35.35 0 0 0-.178-.305.356.356 0 0 0-.355.003L3.173 6.61A.35.35 0 0 0 3 6.912v10.176c0 .13.072.248.187.31l8.63 4.56a.354.354 0 0 0 .337-.002l8.31-4.561a.351.351 0 0 0 .012-.608Z",
    className: "cluster__Amazon-Elastic-Container-Kubernetes_Icon_64_Squid",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEksCluster);
export default __webpack_public_path__ + "static/media/eks_cluster.999c715413d0e70b90efc662db65afeb.svg";
export { ForwardRef as ReactComponent };